import { DictProposalType, DictProposalTypeDbName, DictionaryProposal, DictionaryProposalDetails, DictionaryProposalOverview } from "../containers/centralView/dictionariesView/manageDictProposals/types/manageDictProposalsProps";
import { formattedDate } from "./dateHelper";
import { Option } from "./../components/shared/selectInput/types/selectInputProps";
import { AuthorsAttributes } from "../contexts/poFormContext";

export const getDictionaryProposalOverview = (details: DictionaryProposalDetails) => {       
    var dictProposals: DictionaryProposalOverview[] = [];
    
    details.dictProposals?.sort((a, b) => b.datA_ZGLOSZENIA! - a.datA_ZGLOSZENIA!)
    .forEach(item => {
        var dateFormat = formattedDate(new Date(item.datA_ZGLOSZENIA!));
        var record: DictionaryProposalOverview = {
            proposalObject: item,
            date: dateFormat,
            userName: item.zglaszajacy?.replace(".", " ")
        }
        
        switch (item.slowniK_NAZWA_DOM) {
            case DictProposalTypeDbName.Author:
                record.dictName = DictProposalType.Author;
                var proposalAuthor = details.authorsDictProposals?.find(element => 
                    element.slownikI_PROPOZYCJE_ID === item.id);
                record.detailObject = proposalAuthor;
                record.description = `${proposalAuthor?.imie} ${proposalAuthor?.nazwisko}${proposalAuthor?.urpawnienia ? ", " + proposalAuthor?.urpawnienia : ""}`;           
                break;
            case DictProposalTypeDbName.Institution:
                record.dictName = DictProposalType.Institution;
                var proposalInstitution = details.institutionsDictProposals?.find(element => 
                    element.slownikI_PROPOZYCJE_ID === item.id);
                record.detailObject = proposalInstitution;
                record.description = `${proposalInstitution?.nazwa}, ${proposalInstitution?.miejscowosc}`;           
                break;
            case DictProposalTypeDbName.AuthorInstitution:
                record.dictName = DictProposalType.AuthorInstitution;
                var proposalAuthorInstitution = details.authorInstitutionDictProposals?.find(element => 
                    element.slownikI_PROPOZYCJE_ID === item.id);
                var relationAuthor = details.authorsDict?.find(element => 
                    element.id === proposalAuthorInstitution?.autoR_ID);
                var relationInstituion = details.institutionsDict?.find(element => 
                    element.id === proposalAuthorInstitution?.instytucjA_ID);
                record.detailObject = proposalAuthorInstitution;
                record.description = `${relationAuthor?.imie} ${relationAuthor?.nazwisko} - ${relationInstituion?.nazwa}`;           
                break;
                case DictProposalTypeDbName.Document:
                record.dictName = DictProposalType.Document;
                var proposalDocument = details.documentsDictProposals?.find(element => 
                    element.slownikI_PROPOZYCJE_ID === item.id);
                record.detailObject = proposalDocument;
                record.description = proposalDocument?.tytul ? proposalDocument.tytul : "";
                break;
            case DictProposalTypeDbName.Publication:
                record.dictName = DictProposalType.Publication;
                var proposalPublication = details.publicationsDictProposals?.find(element => 
                    element.slownikI_PROPOZYCJE_ID === item.id);
                record.detailObject = proposalPublication;
                record.description = proposalPublication?.publikacjA_SOPO ? proposalPublication.publikacjA_SOPO : "";
        }
        dictProposals.push(record);
    })
    
    return dictProposals;
}

export const getDictProposalsDetails = (dictProposals: DictionaryProposal[], completeDetails: DictionaryProposalDetails) => {
    var details: DictionaryProposalDetails = {
        dictProposals: [],
        authorsDictProposals: [],
        institutionsDictProposals: [],
        authorInstitutionDictProposals: [],
        documentsDictProposals: [],
        publicationsDictProposals: [],
        authorsDict: completeDetails.authorsDict,
        institutionsDict: completeDetails.institutionsDict
    }

    dictProposals.forEach(item => {
        details.dictProposals?.push(item);
        switch(item.slowniK_NAZWA_DOM) {
            case DictProposalTypeDbName.Author:
                var authorProposal = completeDetails.authorsDictProposals!.find(element => element.slownikI_PROPOZYCJE_ID === item.id);
                details.authorsDictProposals?.push(authorProposal!);
                break;
            case DictProposalTypeDbName.Institution:
                var institutionProposal = completeDetails.institutionsDictProposals!.find(element => element.slownikI_PROPOZYCJE_ID === item.id);
                details.institutionsDictProposals?.push(institutionProposal!);
                break;
            case DictProposalTypeDbName.AuthorInstitution:
                var relation = completeDetails.authorInstitutionDictProposals!.find(element => element.slownikI_PROPOZYCJE_ID === item.id);
                details.authorInstitutionDictProposals?.push(relation!);
                break;
            case DictProposalTypeDbName.Document:
                var documentProposal = completeDetails.documentsDictProposals!.find(element => element.slownikI_PROPOZYCJE_ID === item.id);
                details.documentsDictProposals?.push(documentProposal!);
                break;
            case DictProposalTypeDbName.Publication:
                var publicationProposal = completeDetails.publicationsDictProposals!.find(element => element.slownikI_PROPOZYCJE_ID=== item.id);
                details.publicationsDictProposals?.push(publicationProposal!);
        }
    });

    return details;
}

export const getFoldoutContent = (row: any, completeDetails: DictionaryProposalDetails, academicTitleDict?: Option[], publicationTypeDict?: Option[]) => {  
    switch(row.dictName) {
        case DictProposalType.Author:           
            return getAuthorFoldoutContent(completeDetails, row.detailObject.id, academicTitleDict);
        case DictProposalType.Institution:            
            return getInstitutionFoldoutContent(completeDetails, row.detailObject.id);
        case DictProposalType.AuthorInstitution:            
            return getAuthorInstitutionFoldoutContent(completeDetails, row.detailObject.objectid, academicTitleDict);
        case DictProposalType.Document:           
            return getDocumentFoldoutContent(completeDetails, row.detailObject.id);
        case DictProposalType.Publication:            
            return getPublicationFoldoutContent(completeDetails, row.detailObject.id, publicationTypeDict);
    }
}

const getAcademicTitle = (author: AuthorsAttributes | undefined, academicTitleDict?: Option[]) => {
    var academicTitle = "";
    if (author && academicTitleDict) {
        var option = academicTitleDict.find(item => item.value === author.tytul);
        if (option && option.name) academicTitle = option.name;
    }
    return academicTitle;
}

const getAuthorFoldoutContent = (completeDetails: DictionaryProposalDetails, id: number, academicTitleDict?: Option[]) => {
    var authorProposal = completeDetails.authorsDictProposals!.find(item => item.id === id);  
    return (
        <>
            <div className="foldout-space foldout-table body-txt-medium-xs">
                <div>   
                    <table><tbody>
                        <tr>
                            <th><span>Tytuł</span> </th>
                            <td>{getAcademicTitle(authorProposal, academicTitleDict)}</td>
                        </tr>
                        <tr>
                            <th><span>Imię</span> </th>
                            <td>{authorProposal?.imie}</td>
                        </tr>
                        <tr>
                            <th><span>Nazwisko</span> </th>
                            <td>{authorProposal?.nazwisko}</td>
                        </tr>
                        <tr>
                            <th><span>Uprawnienia</span> </th>
                            <td>{authorProposal?.urpawnienia}</td>
                        </tr>
                    </tbody></table>
                </div>
            </div>
        </>
    );
}

const getInstitutionFoldoutContent = (completeDetails: DictionaryProposalDetails, id: number) => {
    var institutionProposal = completeDetails.institutionsDictProposals!.find(item => item.id === id);
    return (
        <>
            <div className="foldout-space foldout-table body-txt-medium-xs">
                <div>   
                    <table><tbody>
                        <tr>
                            <th><span>Nazwa</span> </th>
                            <td>{institutionProposal?.nazwa}</td>
                        </tr>
                        <tr>
                            <th><span>Miejscowość</span> </th>
                            <td>{institutionProposal?.miejscowosc}</td>
                        </tr>
                    </tbody></table>
                </div>
                <div>   
                    <table><tbody>
                        <tr>
                            <th><span>Ulica</span> </th>
                            <td>{institutionProposal?.ulica}</td>
                        </tr>
                        <tr>
                            <th><span>Nr</span> </th>
                            <td>{institutionProposal?.nr}</td>
                        </tr>
                        <tr>
                            <th><span>Kod</span> </th>
                            <td>{institutionProposal?.kod}</td>
                        </tr>
                    </tbody></table>
                </div>
            </div>
        </>
    );
}

const getAuthorInstitutionFoldoutContent = (completeDetails: DictionaryProposalDetails, id: number, academicTitleDict?: Option[]) => {
    var relation = completeDetails.authorInstitutionDictProposals!.find(item => item.objectid === id);
    var author = completeDetails.authorsDict?.find(item => item.id === relation?.autoR_ID);
    var institution = completeDetails.institutionsDict?.find(item => item.id === relation?.instytucjA_ID);
    return (
        <>
            <div className="foldout-space foldout-table body-txt-medium-xs">
                <div>   
                    <table><tbody>
                        <tr style={{textDecoration: "underline"}}>
                            <th>AUTOR</th>
                        </tr>
                        <tr>
                            <th><span>Tytuł</span> </th>
                            <td>{getAcademicTitle(author, academicTitleDict)}</td>
                        </tr>
                        <tr>
                            <th><span>Imię</span> </th>
                            <td>{author?.imie}</td>
                        </tr>
                        <tr>
                            <th><span>Nazwisko</span> </th>
                            <td>{author?.nazwisko}</td>
                        </tr>
                        <tr>
                            <th><span>Uprawnienia</span> </th>
                            <td>{author?.uprawnienia}</td>
                        </tr>
                    </tbody></table>
                </div>
                <div>   
                    <table><tbody>
                        <tr style={{textDecoration: "underline"}}>
                            <th>INSTYTUCJA</th>
                        </tr>
                        <tr>
                            <th><span>Nazwa</span> </th>
                            <td>{institution?.nazwa}</td>
                        </tr>
                        <tr>
                            <th><span>Miejscowość</span> </th>
                            <td>{institution?.miejscowosc}</td>
                        </tr>
                        <tr>
                            <th><span>Ulica</span> </th>
                            <td>{institution?.ulica}</td>
                        </tr>
                        <tr>
                            <th><span>Nr</span> </th>
                            <td>{institution?.nr}</td>
                        </tr>
                        <tr>
                            <th><span>Kod</span> </th>
                            <td>{institution?.kod}</td>
                        </tr>
                    </tbody></table>
                </div>
            </div>
        </>
    );
}

const getDocumentFoldoutContent = (completeDetails: DictionaryProposalDetails, id: number) => {
    var documentProposal = completeDetails.documentsDictProposals!.find(item => item.id === id);
    return (
        <>
            <div className="foldout-space foldout-table body-txt-medium-xs">
                <div>   
                    <table><tbody>
                        <tr>
                            <th><span>Tytuł</span> </th>
                            <td>{documentProposal?.tytul}</td>
                        </tr>
                        <tr>
                            <th><span>Rok</span> </th>
                            <td>{documentProposal?.rok}</td>
                        </tr>
                        <tr>
                            <th><span>Autorzy</span> </th>
                            <td>{documentProposal?.autorzy}</td>
                        </tr>                      
                    </tbody></table>
                </div>
                <div>   
                    <table><tbody>
                        <tr>
                            <th><span>Numery inwentarzowe</span> </th>
                            <td>{documentProposal?.numerY_INW}</td>
                        </tr>
                        <tr>
                            <th><span>Nazwa archiwum</span> </th>
                            <td>{documentProposal?.nazwA_ARCHIWUM}</td>
                        </tr>
                        <tr>
                            <th><span>Nazwa firmy</span> </th>
                            <td>{documentProposal?.nazwA_FIRMY}</td>
                        </tr>
                    </tbody></table>
                </div>
            </div>
        </>
    );
}

const getNamePublicationType = (publicationType: number | null | undefined, publicationTypeDict?: Option[]) => {
    return publicationTypeDict?.find((value) => value.value === publicationType)?.name;
}

const getPublicationFoldoutContent = (completeDetails: DictionaryProposalDetails, id: number, publicationTypeDict?: Option[]) => {
    var publicationProposal = completeDetails.publicationsDictProposals!.find(item => item.id === id);
    return (
        <>
            <div className="foldout-space foldout-table body-txt-medium-xs">
                <div>   
                    <table><tbody>
                        <tr>
                            <th><span>Publikacja</span> </th>
                            <td>{publicationProposal?.publikacjA_SOPO}</td>
                        </tr>
                        <tr>
                            <th><span>Typ publikacji</span> </th>
                            <td>{getNamePublicationType(publicationProposal?.tyP_PUBLIKACJI_SID, publicationTypeDict)}</td>
                        </tr>
                        <tr>
                            <th><span>Rok powstania</span> </th>
                            <td>{publicationProposal?.roK_POWSTANIA}</td>
                        </tr>
                        <tr>
                            <th><span>Autorzy</span> </th>
                            <td>{publicationProposal?.autorzy}</td>
                        </tr>
                    </tbody></table>
                </div>
                <div>   
                    <table><tbody>
                        <tr>
                            <th><span>Nazwa czasopisma</span> </th>
                            <td>{publicationProposal?.czasopismO_NAZWA}</td>
                        </tr>
                        <tr>
                            <th><span>Oznaczenie czasopisma</span> </th>
                            <td>{publicationProposal?.czasopismO_OZNACZENIE}</td>
                        </tr>
                        <tr>
                            <th><span>Nazwa wydawnictwa</span> </th>
                            <td>{publicationProposal?.wydawnictwO_NAZWA}</td>
                        </tr>
                    </tbody></table>
                </div>
            </div>
        </>
    );
}